var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c("div", { class: _vm.$style.topButtonRow }, [
      _c(
        "div",
        { class: _vm.$style.backButton, on: { click: _vm.handleBackClick } },
        [
          _c("NsIcon", { attrs: { "icon-name": "icon-chevron-left" } }),
          _vm._v(" "),
          _c("div", { class: _vm.$style.backLink }, [
            _vm._v(_vm._s(_vm.backText)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$style.printButton,
          attrs: { "data-testid": "print-button", title: "print" },
          on: { click: _vm.handlePrint },
        },
        [_c("NsIcon", { attrs: { "icon-name": "icon-print" } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.success }, [
      _vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.receipt }, [
      _c("div", { class: _vm.$style.headerImgWrapper }, [
        _c("div", { class: _vm.$style.headerIconWrapper }, [
          _c("div", { class: _vm.$style.headerIcon }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.title }, [
        _vm._v(_vm._s(_vm.receiptFromText) + " " + _vm._s(_vm.description)),
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.receiptId }, [
        _vm._v(_vm._s(_vm.receiptLabel) + " #" + _vm._s(_vm.receiptId)),
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.content }, [
        _c("div", { class: _vm.$style.receiptDetails }, [
          _c("div", [
            _c("div", { class: _vm.$style.subtitle }, [
              _vm._v(_vm._s(_vm.amountPaidLabel)),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v("$" + _vm._s(_vm.amount))]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { class: _vm.$style.subtitle }, [
              _vm._v(_vm._s(_vm.datePaidLabel)),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.transactionDate))]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { class: _vm.$style.subtitle }, [
              _vm._v(_vm._s(_vm.paymentMethodLabel)),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v("**** " + _vm._s(_vm.cardLast4))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style.subtitle }, [
          _vm._v(_vm._s(_vm.summaryLabel)),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style.lineItems }, [
          _c("div", { class: _vm.$style.lineItem }, [
            _c("div", [_vm._v(_vm._s(_vm.nuskinDonationLabel))]),
            _vm._v(" "),
            _c("div", [_vm._v("$" + _vm._s(_vm.amount))]),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.lineItem }, [
            _c("div", [_vm._v(_vm._s(_vm.amountChargedLabel))]),
            _vm._v(" "),
            _c("div", [_vm._v("$" + _vm._s(_vm.amount))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style.separator }),
        _vm._v(" "),
        _c("div", { class: _vm.$style.questions }, [
          _vm._v("\n        " + _vm._s(_vm.questionsMessage) + "\n      "),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.$style.separator }),
        _vm._v(" "),
        _c("div", { class: _vm.$style.info }, [
          _c("p", [_vm._v(_vm._s(_vm.sentToEmailMessage))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }